import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { APP_DEFINITIONS, type AppId } from '@homeapp/shared';

function Tile({ appId, def }: { appId: AppId; def: typeof APP_DEFINITIONS[AppId] }) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(def.path)}
      className={`${def.color} rounded-2xl p-6 text-white text-left hover:opacity-90 active:scale-95 transition-all shadow-md min-h-[120px] flex flex-col justify-between`}
    >
      <span className="text-3xl">{def.icon}</span>
      <span className="text-lg font-semibold mt-2">{def.label}</span>
    </button>
  );
}

export default function TileGrid() {
  const { user } = useAuth();
  if (!user) return null;

  const accessSet = new Set(user.access);
  // Admin role always gets all app tiles.
  if (user.role === 'admin') {
    for (const appId of Object.keys(APP_DEFINITIONS) as AppId[]) {
      accessSet.add(appId);
    }
  }

  const visibleApps = (Object.keys(APP_DEFINITIONS) as AppId[]).filter(id => accessSet.has(id));

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
      {visibleApps.map(appId => (
        <Tile key={appId} appId={appId} def={APP_DEFINITIONS[appId]} />
      ))}
    </div>
  );
}
